import { useAtomValue } from "jotai"
import { useEffect } from "react";
import { scheduleStore } from "store/scheduleStore";

export const useScheduleList = () => {
    const scheduleListState = useAtomValue(scheduleStore.scheduleList.stateAtom);

    useEffect(() => {
        return () => {
            scheduleStore.scheduleList.onDefault();
        }
    }, []);

    return {
        status: scheduleListState.status,
        data: scheduleListState.data,
        error: scheduleListState.error
    };
}

export const useCreateSchedule = () => {
    const createScheduleState = useAtomValue(scheduleStore.createSchedule.stateAtom);

    useEffect(() => {
        return () => {
            scheduleStore.createSchedule.onDefault();
        }
    }, []);

    return {
        status: createScheduleState.status,
        data: createScheduleState.data,
        error: createScheduleState.error
    };
}

export const useVoteSchedule = () => {
    const voteScheduleState = useAtomValue(scheduleStore.voteSchedule.stateAtom);

    useEffect(() => {
        return () => {
            scheduleStore.voteSchedule.onDefault();
        }
    }, []);

    return {
        status: voteScheduleState.status,
        data: voteScheduleState.data,
        error: voteScheduleState.error
    };
}

export const useConfirmSchedule = () => {
    const confirmScheduleState = useAtomValue(scheduleStore.confirmSchedule.stateAtom);

    useEffect(() => {
        return () => {
            scheduleStore.confirmSchedule.onDefault();
        }
    }, []);

    return {
        status: confirmScheduleState.status,
        data: confirmScheduleState.data,
        error: confirmScheduleState.error
    };
}

export const useAiRecommendSchedule = () => {
    const aiRecommendScheduleState = useAtomValue(scheduleStore.aiRecommendSchedule.stateAtom);

    useEffect(() => {
        return () => {
            scheduleStore.aiRecommendSchedule.onDefault();
        }
    }, []);

    return {
        status: aiRecommendScheduleState.status,
        data: aiRecommendScheduleState.data,
        error: aiRecommendScheduleState.error
    };
}
